//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TheRadarBadge from "@/components/TheRadarBadge";
import TheRadarMonthBadge from "@/components/TheRadarMonthBadge";
import TheRadarIsiBadge from "@/components/TheRadarIsiBadge";
import TheRadarTopFiftyBadge from "@/components/TheRadarTopFiftyBadge";

export default {
  name: "TheRadarIcon",

  components: { TheRadarBadge, TheRadarMonthBadge, TheRadarIsiBadge, TheRadarTopFiftyBadge },

  props: {
    placement: {
      type: String,
      default: 'bottomLeft'
    }
  },

  data() {
    return {
      showBadge: false
    }
  }
}
